import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddItem = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11 21V13H3V11H11V3H13V11H21V13H13V21H11Z" })
});
export default SvgAddItem;
